import { v4 as uuidv4 } from 'uuid';

import {
  KanbanColumn,
  KanbanItem,
  KdKanban,
  ProvinceLite,
} from '../../@types/State';

export const getNewColumn = (
  provinceLites: ProvinceLite[],
  count: number,
  offset: number,
  title: string
) => {
  return {
    title: title,
    items: getItems(provinceLites, count, offset),
  } as KanbanColumn;
};

export const getItems = (
  provinceLites: ProvinceLite[],
  count: number,
  offset = 0
) =>
  Array.from({ length: count }, (v, k) => k + offset).map((k) => ({
    id: uuidv4(),
    content: '',
    province: provinceLites[k],
  })) as KanbanItem[];

export const reorderItems = (
  list: KanbanItem[],
  startIndex: number,
  endIndex: number
) => {
  const newItemList = Array.from(list);
  const [removed] = newItemList.splice(startIndex, 1);
  newItemList.splice(endIndex, 0, removed);

  return newItemList;
};

const getExistingIds = (state: KdKanban) => {
  const existingProvinceIds: number[] = [];
  state.columns.forEach((c) => {
    c.items.forEach((i) => {
      existingProvinceIds.push(i.province.id);
    });
  });
  return existingProvinceIds;
};
export const addToBoard = (
  state: KdKanban,
  province: ProvinceLite | undefined,
  setState: (state: KdKanban) => void
) => {
  const exists = province && getExistingIds(state).includes(province.id);
  const newState = { ...state };
  const newColumns = [
    ...state.columns,
    {
      title: 'change me',
      items:
        exists || province === undefined
          ? []
          : [
              {
                id: uuidv4(),
                content: '',
                province: province,
              },
            ],
    } as KanbanColumn,
  ];
  newState.columns = newColumns;
  setState(newState);
};

export const addAllToBoard = (
  state: KdKanban,
  provinces: ProvinceLite[] | undefined,
  setState: (state: KdKanban) => void
) => {
  const newState = { ...state };
  const items: KanbanItem[] | undefined = provinces
    ?.filter((x) => !getExistingIds(state).includes(x.id))
    .map(
      (p) =>
        ({
          id: uuidv4(),
          content: '',
          province: p,
        } as KanbanItem)
    );
  if (items && items.length) {
    const newColumns: KanbanColumn[] = [
      ...state.columns,
      {
        title: 'Unassigned',
        items: items ?? [],
      } as KanbanColumn,
    ];

    newState.columns = newColumns;
    setState(newState);
  }
};

export const moveItemToOtherList = (
  srcColumn: KanbanColumn,
  destCol: KanbanColumn,
  droppableSource: any,
  droppableDestination: any
) => {
  const sourceCloneItems: KanbanItem[] = Array.from(srcColumn.items);
  const destCloneItems: KanbanItem[] = Array.from(destCol.items);
  const [removedItem]: KanbanItem[] = sourceCloneItems.splice(
    droppableSource.index,
    1
  );
  removedItem.province.requiredOps = removedItem.province.requiredOps?.filter(
    (x) => !srcColumn.requiredOps?.includes(x)
  );
  destCol.requiredOps?.forEach((o) => {
    if (!removedItem.province.requiredOps) {
      removedItem.province.requiredOps = [];
    }
    removedItem.province.requiredOps.push(o);
  });
  destCloneItems.splice(droppableDestination.index, 0, removedItem);
  srcColumn.items = sourceCloneItems;
  destCol.items = destCloneItems;
  const result = [];
  result[droppableSource.droppableId] = srcColumn;
  result[droppableDestination.droppableId] = destCol;

  return result;
};

export const initialState: KdKanban = {
  title: 'title',
  content: 'some content',
  columns: [],
};
